import { PhxSelectValue } from '../select/select.types';

type WithOptional<T, K extends keyof T> = Omit<T, K> & Partial<Pick<T, K>>;

export interface PhxOmniOption {
  value: PhxSelectValue;
  label: string;
  domain: string;
  subText?: string;
  prefixIcon?: string;
  data?: { [key: string]: any };
  shouldHighlightMatchedSubtext?: boolean;
  status? : ENTITY_STATUS;
}

export type PhxOmniQuickOption = WithOptional<PhxOmniOption, 'domain'>;

export interface PhxDomainConfig {
  name: PhxDomainOptions;
  label: string;
  icon: string;
  placeholder?: string;
  popularLabel?: string;
  primaryKey?: string;
  secondaryKeys?: string[];
  searchKeys?: string[];
  quickOptions?: PhxOmniQuickOption[];
  includeDeactivated?: boolean;
  navigateTo?: (omniOption: PhxOmniOption) => any[]; // For omnisearch only, to navigate to a specific domain page
}

export type PhxDomains = { [key: string]: PhxDomainConfig };

export enum PhxDomainOptions {
  ALL = 'all',
  VEHICLE = 'vehicles',
  DRIVER = 'drivers',
  ASSET = 'assets',
  GEOFENCE = 'geofences',
  FLEET_USER = 'dispatchers',
  DEVICE = 'devices',
  CARD = 'cards',
  MERCHANT = 'merchants',
  SERVICE = 'service',
  DISPATCH = 'dispatches',
}

export interface PhxSelectedOmniOptionsByDomain {
  [key: string]: PhxOmniOption[];
}

export enum ENTITY_STATUS {
   DEACTIVE = 'deactivated',
   ACTIVE = 'active',
}
